module.exports = "/assets/data/f9c54a6e7e274d1843f4108d75a3a825-NG2.data.json";